import React from 'react';

const Container = ({ children, className = '', styles, ...otherProps }) => (
  <div className={`container ${className}`} {...otherProps}>
    {children}
  </div>
);

export default Container;
